import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Journey } from "@/components/site/Journey";
import { Vision } from "@/components/site/Vision";
import { PublicService } from "@/components/site/PublicService";
import { Updates } from "@/components/site/Updates";
import { LeadershipInAction, CreatingImpact } from "@/components/site/Impact";
import { Gallery } from "@/components/site/Gallery";
import { ContactSection } from "@/components/site/ContactSection";
import { Closing, Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { ArticlesPage } from "@/components/site/ArticlesPage";
import { ArticlePage } from "@/components/site/ArticlePage";

const PATH_TO_ID = {
  "/about": "#about", "/journey": "#journey", "/vision": "#vision",
  "/public-service": "#service", "/updates": "#updates",
  "/gallery": "#gallery", "/contact": "#contact",
};

function Home() {
  const location = useLocation();
  useEffect(() => {
    const id = PATH_TO_ID[location.pathname];
    const t = setTimeout(() => {
      const el = id ? document.querySelector(id) : null;
      if (el) {
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
        else el.scrollIntoView({ behavior: "smooth" });
      } else if (location.pathname === "/") {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
      }
    }, 400);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <main>
      <Hero />
      <About />
      <Journey />
      <Vision />
      <PublicService />
      <LeadershipInAction />
      <CreatingImpact />
      <Updates />
      <Gallery />
      <ContactSection />
      <Closing />
    </main>
  );
}

// Reset scroll to top when navigating to article routes.
function RouteScroller() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/articles")) {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Navbar />
      <RouteScroller />
      <Routes>
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/articles/:slug" element={<ArticlePage />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
